import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M26.37 41.3a2.66 2.66 0 0 1-4.74 0l-3.069-6.03a192.55 192.55 0 0 1-7.951-.407 6.204 6.204 0 0 1-5.737-5.644 101.504 101.504 0 0 1-.373-8.9c0-3.1.124-6.057.371-8.874a6.205 6.205 0 0 1 5.744-5.647c5.18-.365 9.66-.548 13.442-.548 3.772 0 8.215.182 13.33.545a6.205 6.205 0 0 1 5.742 5.646c.247 2.819.371 5.778.371 8.877 0 3.112-.125 6.082-.374 8.91a6.204 6.204 0 0 1-5.73 5.644 182.27 182.27 0 0 1-7.962.406L26.37 41.3Zm-9.46-27.218h14.18c1.183 0 1.183 1.773 0 1.773H16.91c-1.183 0-1.183-1.773 0-1.773Zm0 5.318h14.18c1.183 0 1.183 1.773 0 1.773H16.91c-1.183 0-1.183-1.773 0-1.773Zm0 5.318h6.204c1.181 0 1.181 1.773 0 1.773h-6.205c-1.182 0-1.182-1.773 0-1.773Z",
      clipRule: "evenodd"
    }
  )
);
var SvgContactFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ContactFilled_default = SvgContactFilled;

export { ContactFilled_default as default };
